import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { FORGOT } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from '../../layouts/yellow_white_logo.png'
import bgImg from './bg.jpg'

const centerBoxFlex = {
  overflow: 'hidden',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export default function ResetPassword() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let user = useSelector((state) => state?.loginState.auth)
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {},
    mode: "all"
  })
  const [param, setParam] = React.useState({})
  const [matchError, setMatchError] = React.useState("")

  const cardRef = React.useRef(null);

  React.useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    const emailFromUrl = params.get("email");
    const id = params.get("becon");
    if (emailFromUrl) {
      setParam({ email: emailFromUrl, id: id });
    }
  }, [])

  return (
    <>
      <Box sx={{ ...centerBoxFlex }}>
        <Box sx={{ ...centerBoxFlex, width: 1, position: 'absolute' }}>


          <Box sx={{
            minWidth: { md: 470, xs: 210 },
            background: '#000000b8', px: 6, py: 5,
            borderRadius: 4
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Box component={'img'} src={authImg} />
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography fontSize={16} fontWeight={400} color="#fff">Reset Password</Typography>

            </Box>
            <Box>
              <Typography fontSize={13} sx={{ mb: 2 }} color="#ffffffff">Welcome to widelapse monitoring system</Typography>
            </Box>
            <Box>
              <form autoComplete="false" onSubmit={handleSubmit((data) => {
                data.id = param.id
                data.email = param.email
                console.log("FORM", data)
                if (data.password) {
                  data.reset_url = null
                }
                else {
                  data.reset_url = window.location.href.replace(/\/?$/, '/') + "reset-password"
                }
                if (data.password !== data.confirm) {
                  setMatchError("Password and confirm password mismatch")
                } else {
                  dispatch({ type: `${FORGOT}_POST`, payload: data });
                }
              })}>
                <Typography color="#fff"> {param.email}</Typography>
                {/* <RFG labelStyle={{ color: "#717171" }} name="email" label="Email" control={control} rules={{ required: true }} className="mb-2">
                  <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                </RFG> */}
                <RFG labelStyle={{ color: "#717171" }} name="password" label="New Password" control={control} rules={{ required: true }} className="mb-2">
                  <input type="password" autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                </RFG>
                <RFG labelStyle={{ color: "#717171" }} name="confirm" label="Confirm Password" control={control} rules={{ required: true }} className="mb-2">
                  <input type="password" autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                </RFG>

                <Button sx={{
                  width: 1, mt: 3, background: '#ffd85f',
                  color: '#000', borderRadius: 2, textTransform: 'capitalize'
                }} type="submit">Submit</Button>
                <Button type="button"
                  onClick={() => { navigate('/') }}
                  sx={{
                    width: 1, my: 2, background: '#000000ff', color: '#ffd85f',
                    borderRadius: 2, textTransform: 'capitalize', border: '1px solid white'
                  }} >Back to login</Button>
              </form>

              <Box fontSize={12} className="error">{user?.message}</Box>
              <Box fontSize={12} className="error">{matchError}</Box>

              <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Powered by widelapse</Typography>
                <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Terms & conditions</Typography>
              </Box>
            </Box>
          </Box>



        </Box >
        <Box component={'img'}
          src={bgImg} sx={
            {
              width: { xs: 'auto', sm: '100%' },
              height: { xs: '100vh' }
            }
          }
        />
      </Box >
    </>
  )
}


